var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex items-center h-screen justify-center"},[_c('div',{staticClass:"text-center grow"},[_c('h1',{staticClass:"text-4xl font-bold"},[_vm._v("Oups..")]),_vm._v(" "),_c('div',{staticClass:"mt-2 text-xl font-light"},[_vm._v(_vm._s(_vm.$tt('Cet espace est suspendu')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-130b9be2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/companies/default/views/Blocked.vue
// module id = null
// module chunks = 